module.exports = __webpack_public_path__ + "media/fonts/gotham-medium-webfont-906e126c6e29613b8921797bd62afba0.woff2";